import React from "react";
import { Avatar, Box, Button, IconButton, Stack, Typography } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import SherpaIcon from "../../assets/Sherpa.svg";

const SherpaHeader = ({
  onBack,
  pastSessionId,
  onReturnToLive,
  onOpenDisclaimer,
  onOpenHistory,
}) => (
  <Box
    sx={{
      px: { xs: 1, sm: 2.5 },
      py: 1.25,
      borderBottom: "1px solid",
      borderColor: "#E5EFEA",
      bgcolor: "#FFFFFF",
      display: "flex",
      alignItems: "center",
      gap: { xs: 0.75, sm: 1 },
    }}
  >
    <IconButton
      aria-label="Go back"
      onClick={onBack}
      sx={{ color: "#1B4436", bgcolor: "#F2FAF6", "&:hover": { bgcolor: "#E5F5ED" } }}
    >
      <ArrowBackIosNewRoundedIcon fontSize="small" />
    </IconButton>
    <Avatar src={SherpaIcon} alt="Sherpa" sx={{ width: { xs: 36, sm: 42 }, height: { xs: 36, sm: 42 } }} />
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        variant="subtitle1"
        noWrap
        sx={{
          fontWeight: 750,
          color: "#164A38",
          lineHeight: 1.25,
          fontSize: { xs: "0.88rem", sm: "1rem" },
        }}
      >
        {pastSessionId ? `Past Session #${pastSessionId}` : "Mindsherpa Wellbeing Guide"}
      </Typography>
      {pastSessionId ? (
        <Typography variant="caption" sx={{ color: "#61766D", fontWeight: 600 }}>
          Read-only session
        </Typography>
      ) : (
        <Stack direction="row" spacing={0.6} alignItems="center" sx={{ mt: 0.25 }}>
          <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#22B573" }} />
          <Typography variant="caption" sx={{ color: "#61766D", fontWeight: 600 }}>
            Online
          </Typography>
        </Stack>
      )}
    </Box>

    {/* Mobile Chat History Button - Visible when left sidebar is hidden on mobile/tablet */}
    {onOpenHistory ? (
      <Button
        size="small"
        startIcon={<HistoryRoundedIcon />}
        onClick={onOpenHistory}
        sx={{
          display: { xs: "inline-flex", md: "none" },
          color: "#0C8F63",
          fontWeight: 700,
          fontSize: { xs: 11, sm: 12 },
          textTransform: "none",
          whiteSpace: "nowrap",
          border: "1px solid #D1E5DC",
          borderRadius: "8px",
          px: { xs: 0.9, sm: 1.2 },
          py: 0.4,
          bgcolor: "#F2FAF6",
          "&:hover": { bgcolor: "#E5F5ED" },
        }}
      >
        History
      </Button>
    ) : null}

    {onOpenDisclaimer ? (
      <Button
        size="small"
        onClick={onOpenDisclaimer}
        sx={{
          color: "#0C8F63",
          fontWeight: 650,
          fontSize: { xs: 11, sm: 12 },
          textTransform: "none",
          whiteSpace: "nowrap",
          border: "1px solid #D1E5DC",
          borderRadius: "8px",
          px: { xs: 0.8, sm: 1.2 },
          py: 0.4,
          display: { xs: pastSessionId ? "none" : "inline-flex", sm: "inline-flex" },
          "&:hover": { bgcolor: "#F2FAF6" },
        }}
      >
        Disclaimer
      </Button>
    ) : null}
    {pastSessionId ? (
      <Button
        size="small"
        onClick={onReturnToLive}
        sx={{
          color: "#0C8F63",
          fontWeight: 700,
          whiteSpace: "nowrap",
          fontSize: { xs: 11, sm: 13 },
          px: { xs: 0.75, sm: 1 },
        }}
      >
        Return to Live
      </Button>
    ) : null}
  </Box>
);

export default SherpaHeader;
